module.exports = __webpack_public_path__ + "img/header-logo.7ed17076.svg";